// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__WzeAw","text":"carousel_text__6LpcT"};